<template>
  <div>
    <v-app-bar flat app color="white" light>
      <v-app-bar-nav-icon @click.stop="menu"></v-app-bar-nav-icon>
      <div class="pr-2 pl-2">
        <v-icon color="primary">mdi-account-multiple-minus</v-icon>
      </div>

      <v-toolbar-title style="color:#84264f; font-weight:bold">
        Bajas
        <v-chip color="primary" class="ml-4">{{ totalNumRows$ }}</v-chip>
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>



    <v-container fluid>
      <v-dialog v-model="delDialog" max-width="290">
        <v-card>
          <v-card-title>Borrar</v-card-title>
          <v-card-text class="subtitle-1"
            >Deseas borrar este ingrediente ?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="delDialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="primary" @click="deleteIngredient()">Sí</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



      <v-toolbar color="secondary" dark flat dense>
        <v-row>
          <v-col cols="12" sm="4" class="text-left">
            <div class="body-1">email (stripe subscription id)</div>
          </v-col>

          <v-col cols="12" sm="2" class="text-left">
            <div class="body-1">reason_key</div>
          </v-col>
          <v-col cols="12" sm="4" class="text-left">
            <div class="body-1">comments</div>
          </v-col>
          <v-col cols="12" sm="2" class="text-left">
            <div class="body-1">created_at</div>
          </v-col>
        </v-row>
      </v-toolbar>

      <ItemList
        :items="items$"
        type="cancellation_reasons"
        :dragAndDropActive="true"
        :totalItems="totalNumRows$"
        @paginationChange="paginationChange($event)"
      />
    </v-container>
  </div>
</template>

<script>
import store from "../../store";
import ItemList from "@/components/itemList";
import { INGREDIENT_ORDER, TABLE_NUM_ITEMS } from "../../constants";

export default {
  data() {
    return {
      delDialog: false,
      itemIdToDelete: null,
      ingredientOrderOptions: INGREDIENT_ORDER,
      ingredientOrderdefaultSelected: INGREDIENT_ORDER[0].value,
      conditions: "",
      searchIngredients: null,
      searchVegan: null,
      sortBy: null,
    };
  },
  components: { ItemList },
  computed: {
    items$() {
      return store.getters["users/cancellationReasons"];
    },
    totalNumRows$() {
      return parseInt(store.getters["users/totalItems"]);
    },
  },
  methods: {
    menu() {
      store.dispatch("user/ToggleMenu");
    },
    onActionTrigger({ event }) {

    },
    deleteIngredient() {

    },

    paginationChange(data) {
      this.search(data.event * TABLE_NUM_ITEMS, TABLE_NUM_ITEMS, this.sortBy);
    },
    selectSorting(evt) {
      this.sortBy = evt;
      this.search(0, TABLE_NUM_ITEMS, this.sortBy);
    },
    searchChange(evt) {
      this.searchIngredients = evt;
      this.search(0, TABLE_NUM_ITEMS, this.sortBy);
    },
    search(offset, limit, search) {
      store
          .dispatch("users/LoadAllCancellationReasons", {
            offset: offset,
            limit: limit,
            email: search,
          })
          .then(() => {});
    },

  },
};
</script>

<style></style>
